export const Env = {
    dev: 'dev',
    test: 'test',
    stg: 'stg',
    prod: 'prod'
};

/**
 * 获取当前环境
 * @description 仅在浏览器内使用
 */
export function getEnv() {
    let env = '';
    if (process.browser) {
        env = window && window.env;
    }
    return env || Env.prod;
}

// export function getEnvFromHost(host) {
//     console.log('[host]', host);
//     if (host.indexOf('localhost') > -1 || host.indexOf('-local') > -1) {
//         return Env.test;
//     }
//     if (host.includes('-dev')) {
//         return Env.dev;
//     }
//     if (host.includes('-test')) {
//         return Env.test;
//     }
//     if (host.includes('-stg')) {
//         return Env.stg;
//     }
//     return Env.prod;
// }

export const UrlConfig = {
    apollo: {
        [Env.dev]: 'https://apollo-dev.nio.com',
        [Env.test]: 'https://apollo-test.nio.com',
        [Env.stg]: 'https://apollo-stg.nio.com',
        [Env.prod]: 'https://apollo.nio.com'
    },
    marketing: {
        [Env.dev]: 'https://marketing-dev.nioint.com',
        [Env.test]: 'https://marketing-test.nioint.com',
        [Env.stg]: 'https://marketing-stg.nio.com',
        [Env.prod]: 'https://marketing.nio.com'
    }
};

export function getInternalUrlWithEnv(key) {
    const env = getEnv();

    return UrlConfig[key][env];
}



// WEBPACK FOOTER //
// ./src/util/env.js